import { ConsentState } from '../model';

const STORAGE_KEY = 'site.consent.v1';

export const defaultConsent: ConsentState = {
  given: false,
  categories: { necessary: true, analytics: false },
};

export const loadConsent = (): ConsentState => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);

    return raw ? JSON.parse(raw) : defaultConsent;
  } catch {
    return defaultConsent;
  }
};

export const saveConsent = (state: ConsentState, gaId: string) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(state));

  if (!state.categories.analytics) {
    try {
      clearAnalyticsCookies(gaId);
    } catch {
      console.error('Failed to clear GA cookie');
    }
  }
};

const getCandidateDomains = (): string[] => {
  const hostname = location.hostname;
  const parts = hostname.split('.');
  const candidates: string[] = [hostname];
  for (let i = 0; i < parts.length - 1; i++) {
    candidates.push(parts.slice(i).join('.'));
  }
  return Array.from(
    new Set([...candidates, ...candidates.map((d) => `.${d}`)])
  );
};

const expireCookie = (name: string, domain?: string) => {
  const expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
  const domainPart = domain ? `; domain=${domain}` : '';
  document.cookie = `${name}=; expires=${expires}; path=/${domainPart};`;
};

const clearAnalyticsCookies = (gaId: string) => {
  const cookieString = document.cookie || '';
  if (!cookieString) return;

  const cookies = cookieString.split(';').map((c) => c.trim());
  const patterns = [
    /^_ga($|_)/,
    /^_gid$/,
    /^_gat/,
    /^_gac_/,
    /^_clck$/,
    /^_clsk$/,
    /^_cl/,
  ];
  const domains = ['.gannet.ai', ...getCandidateDomains()];
  cookies.forEach((kv) => {
    const [name] = kv.split('=');
    if (!name) return;
    if (patterns.some((re) => re.test(name))) {
      expireCookie(name);
      domains.forEach((d) => expireCookie(name, d));
    }
  });

  try {
    if (gaId) {
      const suffix = gaId.split('-')[1] ?? gaId;
      const propName = `_ga_${suffix}`;
      expireCookie(propName);
      domains.forEach((d) => expireCookie(propName, d));
    }
  } catch {
    console.error('Failed to clear GA property cookie');
  }
};
